/* eslint-disable react-doctor/no-tiny-text */
import type { CSSProperties } from "react";

interface ChromeProps {
  children: React.ReactNode;
  color?: string;
  style?: CSSProperties;
}

export function Chrome({ children, color = "var(--tls-fg-subtle)", style }: ChromeProps) {
  return (
    // eslint-disable-next-line react-doctor/no-tiny-text
    <span
      style={{
        fontFamily: "var(--tls-font-display)",
        // The ONE label atom: DS `--ls-type-label` = 11px / 700 / +0.18em,
        // uppercase. `.tls-eyebrow` in globals.css is the class twin of this
        // recipe; nothing else in the app may fork it.
        fontWeight: 700,
        // §15.2: labels are a REM category (the user's font-size setting
        // is the most-used accessibility control on the web). 11px at the
        // 16px reference root — the design system's label floor ("11px
        // label token is the floor; uppercase reserved for it").
        fontSize: "0.6875rem",
        lineHeight: 1.3,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        color,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
